import type { DBCharacter } from '../../../../services/CharacterService';
import { EQUIPMENT_SCHEMA_SLOTS, type EquipmentSchemaSlot } from '../../../../../shared/equipmentSlots';
import { resolvePlayerEquipmentVisuals } from '../../../../../shared/equipmentVisuals';

/** Read only authoritative equipped IDs. Inventory and cosmetic variants are separate. */
export function rosterEquipmentIds(character: Pick<DBCharacter, 'equipment'>): Partial<Record<EquipmentSchemaSlot, string>> {
  const source: unknown = character.equipment;
  if (!source || typeof source !== 'object') return {};
  const ids: Partial<Record<EquipmentSchemaSlot, string>> = {};
  for (const slot of EQUIPMENT_SCHEMA_SLOTS) {
    const value = source instanceof Map ? source.get(slot) : (source as Record<string, unknown>)[slot];
    if (typeof value === 'string' && value.length > 0) ids[slot] = value;
  }
  return ids;
}

export function rosterEquipmentVisuals(character: Pick<DBCharacter, 'equipment'>) {
  return resolvePlayerEquipmentVisuals(rosterEquipmentIds(character));
}

/** Format only the saved map identity; do not invent an entry destination. */
export function rosterLocation(character: Pick<DBCharacter, 'levelId' | 'currentLevelId'>): string {
  const id = character.levelId?.trim() || character.currentLevelId?.trim();
  if (!id) return 'Location unknown';
  return id.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim()
    .replace(/\b[a-z]/g, letter => letter.toUpperCase());
}
